export default __webpack_public_path__ + "static/ro_unit_b.1462935f9c4fcb0b0240c90d29297a8d.svg";